import './App.css';
import Clock from './Clock/Clock'
function App(){
  return(
    <div className="App">
      <Clock/>
    </div>
  )
}


export default App;
